import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createUserCategory',
    serviceName: 'unitadmin',
    query: gql`
      mutation createUserCategory($title: String!, $lab_id: String, $unit_id: String, $parent_id: String) {
        createUserCategory(title: $title, lab_id: $lab_id, unit_id: $unit_id, parent_id: $parent_id) {
          messages
        }
      }
    `,
  },
};

export default schema;
